import { Box, Tooltip, Typography } from '@mui/material';
import { useContext } from 'react';

import { AppContext } from '../app/context';

import { PremiumIcon } from './icons';

export function PremiumBadge({
  targetOffer: offer,
  limited,
}: {
  limited?: boolean;
  targetOffer?: 'premium';
}): React.JSX.Element {
  const {
    partner: { type: partnerType },
  } = useContext(AppContext);

  if (!partnerType) return <></>;

  return (
    <Tooltip
      placement="bottom"
      title={
        limited
          ? 'Cette fonctionnalité est limitée en offre Gratuite'
          : partnerType === 'free'
            ? offer === 'premium'
              ? "Cette fonctionnalité n'est disponible que dans l'offre Premium"
              : "Cette fonctionnalité n'est disponible que dans les offres payantes"
            : ''
      }
    >
      <Box alignItems="center" display="flex" gap={1}>
        <Box
          alignItems="center"
          bgcolor="#EEE8FD"
          border="1px solid #B396EF"
          borderRadius={2}
          display="flex"
          gap={0.5}
          paddingX={1}
          paddingY={0.5}
        >
          <PremiumIcon sx={{ color: '#6236BD', height: 14, width: 14 }} />
          <Typography color="#491EA1" lineHeight="14px" variant="caption">
            {limited ? 'Fonctionnalité limitée' : 'Fonctionnalité payante'}
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
}
